import { gql } from '@apollo/client';

export const CONFIRM_MOBILE_NUMBER = gql`
  mutation confirmMobileNumberExists($mobileNumber: String!, $userId: ID) {
    confirmMobileNumberExists(data: { mobileNumber: $mobileNumber, userId: $userId }) {
      mobileNumberExists
    }
  }
`;
